"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledButton = _interopRequireDefault(require("../../buttons/styledButton"));

var _error_ = _interopRequireDefault(require("./img/error_404.png"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container404 = _styledComponents["default"].div.withConfig({
  displayName: "sc-404__Container404",
  componentId: "sc-1pireci-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    min-height: 100%;\n    height: auto;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 10px;\n"])));

var ContainerImg = _styledComponents["default"].div.withConfig({
  displayName: "sc-404__ContainerImg",
  componentId: "sc-1pireci-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    width: 100%;\n    text-align: center;\n    margin-top: 50px;\n    margin-bottom: 20px;\n    display: block;\n"])));

var ContainerButton = _styledComponents["default"].div.withConfig({
  displayName: "sc-404__ContainerButton",
  componentId: "sc-1pireci-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    margin-top: 20px;\n    width: 100%;\n    max-width: 840px;\n    justify-content: center;\n    @media (max-width: 1187px) {\n        max-width: 420px;\n    }\n"])));

var Img = _styledComponents["default"].img.withConfig({
  displayName: "sc-404__Img",
  componentId: "sc-1pireci-3"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    width: auto;\n    max-width: 100%;\n    vertical-align: top;\n"])));

var Text404 = _styledComponents["default"].div.withConfig({
  displayName: "sc-404__Text404",
  componentId: "sc-1pireci-4"
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    & h1 {\n        vertical-align: middle;\n        margin-bottom: 20px;\n        font-family: 'robotoLight',Arial,Helvetica,sans-serif;\n        font-size: 44px;\n        line-height: 56px;\n        font-weight: 100;\n        @media (max-width: 1187px) {\n            font-size: 32px;\n            line-height: 40px;\n        }\n    }\n    & p {\n        font-family: 'robotoLight',Arial,Helvetica,sans-serif;\n        font-size: 16px;\n        line-height: 24px;\n        margin: 0;\n    }  \n"])));

var Button404 = (0, _styledComponents["default"])(_styledButton["default"]).withConfig({
  displayName: "sc-404__Button404",
  componentId: "sc-1pireci-5"
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    width: auto;\n    margin-right: 20px;\n    margin-left: 20px;\n    margin-bottom: 10px;\n    @media (max-width: 1187px) {\n        margin-bottom: 20px;\n    }\n}\n"])));

var Index = /*#__PURE__*/function (_PureComponent) {
  _inherits(Index, _PureComponent);

  var _super = _createSuper(Index);

  function Index() {
    var _this;

    _classCallCheck(this, Index);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      showButton: ['bundles', 'domrutv', 'internet', 'support'],
      mainMenuData: []
    });

    return _this;
  }

  _createClass(Index, [{
    key: "render",
    value: function render() {
      var currentCity = this.props.currentCity;
      var _this$state = this.state,
          showButton = _this$state.showButton,
          mainMenuData = _this$state.mainMenuData;
      var filteredMenu = mainMenuData.filter(function (item) {
        return ~showButton.indexOf(item.link_name);
      }).map(function (item) {
        return /*#__PURE__*/_react["default"].createElement(Button404, {
          key: item.id,
          type: "secondary",
          href: item.link_path,
          text: item.link_title
        });
      });
      return /*#__PURE__*/_react["default"].createElement(Container404, null, /*#__PURE__*/_react["default"].createElement(ContainerImg, null, /*#__PURE__*/_react["default"].createElement(Img, {
        src: _error_["default"],
        alt: "404"
      })), /*#__PURE__*/_react["default"].createElement(Text404, null, /*#__PURE__*/_react["default"].createElement("h1", null, "\u042D\u0442\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430"), /*#__PURE__*/_react["default"].createElement("p", null, "\u0422\u0430\u043A\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u0431\u043E\u043B\u044C\u0448\u0435 \u043D\u0435\u0442 \u0438\u043B\u0438 \u0432\u044B \u043D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u043E \u0432\u0432\u0435\u043B\u0438 \u0430\u0434\u0440\u0435\u0441."), /*#__PURE__*/_react["default"].createElement("p", null, "\u041D\u043E \u0443 \u043D\u0430\u0441 \u0435\u0449\u0451 \u043C\u043D\u043E\u0433\u043E \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043D\u043E\u0433\u043E \u0438 \u043F\u043E\u043B\u0435\u0437\u043D\u043E\u0433\u043E.")), currentCity ? /*#__PURE__*/_react["default"].createElement(ContainerButton, null, filteredMenu) : '');
    }
  }]);

  return Index;
}(_react.PureComponent);

var _default = Index;
exports["default"] = _default;